/* src/shared/ui/mtr-link-modal/mtr-link-modal.component.scss */
:host {
  display: block;
}
.mtr-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(3, 7, 18, 0.82);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  animation: fadeInBackdrop 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.mtr-modal-container {
  position: relative;
  width: 100%;
  max-width: 460px;
  background: #111726;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 28px 28px 24px;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.04),
    0 24px 48px -12px rgba(0, 0, 0, 0.85),
    0 0 40px rgba(37, 99, 235, 0.12);
  color: #f8fafc;
  display: flex;
  flex-direction: column;
  gap: 18px;
  animation: scaleInCard 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  box-sizing: border-box;
}
.mtr-modal-container.shake {
  animation: modalShake 0.4s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
@media (max-width: 480px) {
  .mtr-modal-container {
    padding: 22px 18px 20px;
    gap: 16px;
    border-radius: 14px;
  }
}
.step-progress-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: -4px;
}
.step-progress-row .step-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 9999px;
  background: #111726;
  border: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  transition: all 0.2s ease;
}
.step-progress-row .step-pill .step-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.68rem;
  font-weight: 700;
  color: #94a3b8;
}
.step-progress-row .step-pill .step-check-svg {
  width: 14px;
  height: 14px;
  color: #10b981;
}
.step-progress-row .step-pill .step-text {
  letter-spacing: 0.01em;
}
.step-progress-row .step-pill.active {
  background: #111726;
  border-color: #3b82f6;
  color: #93c5fd;
}
.step-progress-row .step-pill.active .step-dot {
  background: #3b82f6;
  color: #ffffff;
}
.step-progress-row .step-pill.complete {
  background: #111726;
  border-color: rgba(16, 185, 129, 0.4);
  color: #6ee7b7;
}
.step-progress-row .step-divider {
  width: 24px;
  height: 1.5px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 1px;
  transition: background 0.2s ease;
}
.step-progress-row .step-divider.complete {
  background: rgba(16, 185, 129, 0.5);
}
.modal-badge-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -2px;
}
.modal-badge-wrapper .modal-badge-glow {
  position: absolute;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(59, 130, 246, 0.2) 0%,
      transparent 70%);
  filter: blur(10px);
  pointer-events: none;
}
.modal-badge-wrapper .modal-badge-icon {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 12px;
  background: #111726;
  border: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #60a5fa;
}
.modal-badge-wrapper .modal-badge-icon .svg-badge {
  width: 24px;
  height: 24px;
}
.modal-header {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.modal-header .modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.015em;
  line-height: 1.3;
}
@media (max-width: 480px) {
  .modal-header .modal-title {
    font-size: 1.15rem;
  }
}
.modal-header .modal-message {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.55;
  color: #94a3b8;
}
@media (max-width: 480px) {
  .modal-header .modal-message {
    font-size: 0.84rem;
  }
}
.account-identifier {
  display: flex;
  justify-content: center;
  margin-top: -4px;
}
.account-identifier .account-pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 12px;
  background: #111726;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 9999px;
  font-size: 0.78rem;
  color: #cbd5e1;
  max-width: 100%;
}
.account-identifier .account-pill .pill-svg {
  width: 14px;
  height: 14px;
  color: #93c5fd;
  flex-shrink: 0;
}
.account-identifier .account-pill .pill-email {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
}
.step-content {
  animation: fadeIn 0.2s ease forwards;
}
.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.form-field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-field-group .field-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #cbd5e1;
  letter-spacing: 0.01em;
}
.form-field-group .field-label.text-center {
  text-align: center;
}
.otp-inputs-grid {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-top: 4px;
}
@media (max-width: 480px) {
  .otp-inputs-grid {
    gap: 6px;
  }
}
.otp-inputs-grid .otp-digit-box {
  width: 48px;
  height: 52px;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 700;
  font-family: inherit;
  background: #090e1a;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  color: #ffffff !important;
  -webkit-text-fill-color: #ffffff !important;
  caret-color: #3b82f6 !important;
  outline: none;
  padding: 0 !important;
  line-height: 50px !important;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}
.otp-inputs-grid .otp-digit-box:hover {
  border-color: rgba(255, 255, 255, 0.28);
}
.otp-inputs-grid .otp-digit-box:focus {
  border-color: #2c4876 !important;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.28) !important;
  background: #0c1424 !important;
}
.otp-inputs-grid .otp-digit-box.has-value {
  border-color: rgba(59, 130, 246, 0.5);
  background: #0c1424;
}
.otp-inputs-grid .otp-digit-box.input-error {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2) !important;
}
.otp-inputs-grid .otp-digit-box:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media (max-width: 480px) {
  .otp-inputs-grid .otp-digit-box {
    width: 40px;
    height: 46px;
    font-size: 1.2rem;
    line-height: 44px !important;
    border-radius: 8px;
  }
}
@media (max-width: 360px) {
  .otp-inputs-grid .otp-digit-box {
    width: 36px;
    height: 42px;
    font-size: 1.1rem;
    line-height: 40px !important;
  }
}
.resend-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.82rem;
  color: #94a3b8;
  margin-top: -2px;
}
.resend-row .resend-label {
  color: #94a3b8;
}
.resend-row .resend-cooldown {
  color: #cbd5e1;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.resend-row .btn-resend {
  background: transparent;
  border: none;
  color: #60a5fa;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-family: inherit;
  text-decoration: none;
  transition: color 0.15s ease;
}
.resend-row .btn-resend:hover:not(:disabled) {
  color: #93c5fd;
  text-decoration: underline;
}
.resend-row .btn-resend:disabled {
  color: #64748b;
  cursor: not-allowed;
  text-decoration: none;
}
.input-shell {
  position: relative;
  display: flex;
  align-items: center;
  background: #090e1a;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  transition: all 0.2s ease;
}
.input-shell:hover {
  border-color: rgba(255, 255, 255, 0.2);
}
.input-shell:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
  background: #0c1424;
}
.input-shell.input-error {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2) !important;
}
.input-shell .input-prefix-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 12px;
  color: #64748b;
  pointer-events: none;
}
.input-shell .input-prefix-icon .key-icon {
  width: 18px;
  height: 18px;
}
.input-shell .password-input {
  flex: 1;
  width: 100%;
  min-width: 0;
  height: 44px;
  background: transparent;
  border: none;
  outline: none;
  padding: 0 10px;
  font-size: 0.92rem;
  color: #ffffff;
  font-family: inherit;
}
.input-shell .password-input::placeholder {
  color: #64748b;
  font-size: 0.88rem;
}
.input-shell .password-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.input-shell .password-toggle-btn {
  background: transparent;
  border: none;
  color: #94a3b8;
  padding: 0 12px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.15s ease;
}
.input-shell .password-toggle-btn:hover {
  color: #f1f5f9;
}
.input-shell .password-toggle-btn .toggle-icon {
  width: 18px;
  height: 18px;
}
.field-error-message {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 4px;
  font-size: 0.8rem;
  line-height: 1.4;
  color: #f87171;
  animation: fadeIn 0.15s ease forwards;
}
.field-error-message.center-error {
  justify-content: center;
  text-align: center;
}
.field-error-message .error-icon {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  margin-top: 1.5px;
  stroke: #f87171;
}
.helper-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -6px;
}
.helper-row .btn-step-back {
  background: transparent;
  border: none;
  padding: 0;
  font-size: 0.78rem;
  font-weight: 500;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease;
}
.helper-row .btn-step-back:hover {
  color: #cbd5e1;
  text-decoration: underline;
}
.helper-row .forgot-password-link {
  font-size: 0.8rem;
  font-weight: 500;
  color: #60a5fa;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s ease, text-decoration 0.15s ease;
}
.helper-row .forgot-password-link:hover {
  color: #93c5fd;
  text-decoration: underline;
}
.action-row {
  margin-top: 2px;
}
.action-row .btn-link-account {
  width: 100%;
  height: 46px;
  border-radius: 8px;
  background:
    linear-gradient(
      135deg,
      #2563eb 0%,
      #1d4ed8 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  font-size: 0.94rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 14px rgba(37, 99, 235, 0.35);
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}
.action-row .btn-link-account:hover:not(:disabled) {
  background:
    linear-gradient(
      135deg,
      #3b82f6 0%,
      #2563eb 100%);
  box-shadow: 0 6px 20px rgba(37, 99, 235, 0.45);
  transform: translateY(-1px);
}
.action-row .btn-link-account:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}
.action-row .btn-link-account:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.action-row .btn-link-account .btn-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
.footer-actions {
  display: flex;
  justify-content: center;
  margin-top: -2px;
}
.footer-actions .btn-logout {
  background: transparent;
  border: none;
  padding: 6px 12px;
  font-size: 0.76rem;
  color: #64748b;
  cursor: pointer;
  transition: color 0.15s ease;
}
.footer-actions .btn-logout:hover {
  color: #94a3b8;
  text-decoration: underline;
}
@keyframes fadeInBackdrop {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes scaleInCard {
  from {
    opacity: 0;
    transform: scale(0.96) translateY(8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@keyframes modalShake {
  0%, 100% {
    transform: translateX(0);
  }
  20%, 60% {
    transform: translateX(-5px);
  }
  40%, 80% {
    transform: translateX(5px);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=mtr-link-modal.component.css.map */
